const hasClipboard = () => typeof window !== 'undefined' && 'clipboard' in navigator

const hasAsyncClipboard = () =>
  hasClipboard() &&
  // eslint-disable-next-line compat/compat
  typeof window.navigator.clipboard.write !== 'undefined' &&
  // eslint-disable-next-line compat/compat
  typeof window.ClipboardItem !== 'undefined'

const makeBlob = async (promise: Promise<string>) => {
  const data = await promise
  return new Blob([data], { type: 'text/plain' })
}

/*
 * This method is really just a workaround for Safari 🧭.
 * ------------------------------------------------------
 * Use this method if you need to invoke an async action
 * before the copy.  This is needed for Safari
 * as otherwise it will view the async action
 * as a delay that will make the copy action
 * not 'user-invoked' and fail.
 * This method falls back to the non-async method
 */
export const copyAsyncText = async (promise: Promise<string>) => {
  if (hasAsyncClipboard()) {
    try {
      // eslint-disable-next-line compat/compat
      const ClipboardItem = window.ClipboardItem!
      // eslint-disable-next-line compat/compat
      await navigator.clipboard.write!([new ClipboardItem({ 'text/plain': makeBlob(promise) })])
      return
    } catch (err) {
      console.log(err)
    }
  }
  if (hasClipboard()) {
    const data = await promise
    await copyText(data)
  }
}

/*
 * Use this method if you have the string already
 * and don't need to invoke an async callback to get string.
 */
export const copyText = async (str: string) => {
  if (hasClipboard()) {
    try {
      // eslint-disable-next-line compat/compat
      await navigator.clipboard.writeText(str)
      return
    } catch (err) {
      console.log(err)
    }
  }
}
